import { useRecoilCallback, useSetRecoilState } from "recoil"
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { professionalDetailFetchState, professionalDetailState } from "../state/atoms"

const useProfessional = () => {

    const setProfessionalDetail = useSetRecoilState(professionalDetailState);
    const { catchErrorApi } = useCatchErrorApi()

    const loadDetailProfessional = useRecoilCallback(({ snapshot }) => async (ptdRut) => {
        try {
            const professionalDetail = await snapshot.getPromise(professionalDetailFetchState(ptdRut));
            setProfessionalDetail(professionalDetail);

            return professionalDetail;

        } catch (error) {
            catchErrorApi(error);
        }
    }, []);

    return {
        loadDetailProfessional
    }
}

export default useProfessional;